import * as dic from './Dic';

export default {
    auditStatusText(value) {
        let item = dic.auditStatusList.find(e => e.value === value);
        return item ? item.label : '';
    },
    goodsFlashSaleStatusText(value) {
        let item = dic.goodsFlashSaleStatusList.find(e => e.value === value);
        return item ? item.label : '';
    }
}